import { Navigate } from 'react-router-dom';
import { withRouter } from 'common/withRouter';
import AuthService from '../../services/AuthService';
import NamedRoute from './NamedRoute';

const PrivateRoute = ({ component: Component, title, ...childProps }) => (
  <NamedRoute
    title={title}
    render={() =>
      AuthService.isAuthenticated() ? (
        <>
          <Component {...childProps} title={title} />
        </>
      ) : (
        <Navigate replace to="/login" />
      )
    }
  />
);

export default withRouter(PrivateRoute);
